import React, { useContext, useLayoutEffect, useState } from 'react';
import Input from '../Input';
import { Regex } from '../../utility/regex';
import { FormContext } from '../Form';

const PhoneNumberInput = ({ ...props }) => {
    const propName = props.name || 'phoneNumber';
    const callback = props.callback;
    delete props.name;
    delete props.callback;

    const context = useContext(FormContext);
    const { values, setValue, setErrors } = context
    const [state, setState] = useState(values[propName]?.toString() ?? '')

    useLayoutEffect(() => {
        if (state === undefined || values[propName] === undefined) return;
        if (values[propName] !== state.replace(/\D/g, '')) {
            setState(values[propName]?.toString().replace(/\D/g, ''));
        }
        if (callback) {
            callback(values[propName])
        }
    }, [values[propName]])

    useLayoutEffect(() => {
        if (!state) return;

        setErrored(state.replace(/\D/g, '').length !== 10)

        let val = state;
        [{
            selector: /^(\d{3}\B)/g,
            replacement: '($1) '
        }, {
            selector: / (\d{3}\B)/g,
            replacement: ' $1-'
        }]
            .forEach(e => val = val.replace(e.selector, e.replacement))

        setState(val);
    }, [state])

    const setErrored = (val) => {
        setErrors(v => ({
            ...v,
            [propName]: val
        }))
    }

    return (
        <>
            <Input
                label={props.label || 'Phone Number'}
                type='tel'
                maxLength={14}
                value={`${state}`}
                sanitize={Regex.match.notNumbers}
                validate={(val, setInvalidMessage, resolve) => {
                    if (val.replace(/\D/g, '').length !== 10) {
                        setErrored(true);
                        setInvalidMessage('Please Enter a valid phone number.');
                        resolve(true)
                    }
                    resolve(false)
                }}
                callback={(e) => {
                    if (e === undefined) return;
                    setState(e);
                    setValue(propName, e);
                }}
                min={14}
                name='phoneMask'
                {...props}
            />
            <input
                name={propName}
                value={values[propName] || ''}
                type='hidden'
                {...props}
            />
        </>

    )
}

export default PhoneNumberInput;
